import { t } from '../../../strings/i18n';
import { max, min, required } from '../../../xform';
export const CARD_NUMBER_INPUT_NAME = 'cardNumber';
const cardNumberConfig = () => [
    CARD_NUMBER_INPUT_NAME,
    undefined,
    'ENABLED',
    [
        required(t('errors.cardNumberRequired')),
        min(t('errors.cardNumberInvalid'), 15, String),
        max(t('errors.cardNumberInvalid'), 16, String)
    ]
];
export default cardNumberConfig;
